import { useTranslation } from 'react-i18next';
import {
  CustomerAuthErrorCodes,
  type CustomerAuthErrorCode,
} from './authErrorCodes.js';

interface AuthDeliveryErrorPanelProps {
  code: CustomerAuthErrorCode;
}

export function AuthDeliveryErrorPanel({
  code,
}: AuthDeliveryErrorPanelProps): JSX.Element | null {
  const { t } = useTranslation('customer');

  if (code === CustomerAuthErrorCodes.OTP_DELIVERY_FAILED) {
    return (
      <div
        className="rounded-md border border-[var(--color-danger)] bg-[var(--color-surface)] p-3 text-sm"
        role="alert"
        data-testid="auth-delivery-error-otp"
      >
        <p className="font-medium text-[var(--color-on-surface)]">
          {t('auth.otpDeliveryFailedTitle')}
        </p>
        <p className="mt-1 text-[var(--color-on-surface-muted)]">
          {t('auth.otpDeliveryFailedBody')}
        </p>
      </div>
    );
  }

  if (code === CustomerAuthErrorCodes.SMS_NOT_AVAILABLE) {
    return (
      <div
        className="rounded-md border border-[var(--color-danger)] bg-[var(--color-surface)] p-3 text-sm"
        role="alert"
        data-testid="auth-delivery-error-sms"
      >
        <p className="font-medium text-[var(--color-on-surface)]">
          {t('auth.smsNotAvailableTitle')}
        </p>
        <p className="mt-1 text-[var(--color-on-surface-muted)]">
          {t('auth.smsNotAvailableBody')}
        </p>
      </div>
    );
  }

  return null;
}
